import React from 'react';
import PropTypes from 'prop-types';

import {
  FormInline,
  FileInput,
} from '../../fragments/forms';
import Button from '../../fragments/button';
import ReferenceSearchBox from './reference-searchbox';

import style from './style.css';
import Reference from '../../../models/reference';


export default class SelectOrUpload extends React.Component {

  static propTypes = {
    reference: PropTypes.object,
    onSelect: PropTypes.func.isRequired,
    onLoadFile: PropTypes.func.isRequired,
  };

  render() {
    const {
      onSelect,
      onLoadFile,
      reference,
    } = this.props;

    return (
      <div className={style.searchorupload}>
        <div className={style.search}>
          <FormInline
           dom='span'
           onSubmit={e=> e && e.preventDefault()}
          >
            <ReferenceSearchBox
             reference={reference}
             onSelect={onSelect}
             key={reference? reference.uuid : ''}
            />
          </FormInline>
        </div>
        <div className={style.orstatement}>
          OR
        </div>
        <div className={style.loadfile}>
          <FormInline>
            <Button
             className={style.smallBtn}
             onClick={() => {onSelect(new Reference());}}
            >Enter a new study not in pubmed
            </Button>
          </FormInline>
        </div>
        <div className={style.orstatement}>
          OR
        </div>
        <div className={style.loadfile}>
          <FormInline>
            <FileInput
             name="uploadXLSX"
             accept={'.xlsx'}
             children={'Load Mangabey file'}
             hideSelected={true}
             onChange={onLoadFile}
            />
          </FormInline>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/wizard/reference/select-or-upload.js